module.exports = __webpack_public_path__ + "img/pay-sdk-transaction-success.833f03de.png";